import { LocaleId } from '@shared/models/language.model';
/**
 * object with the region and its locale ids
 */
const Regions = {
  apac: [LocaleId.IndiaEnglish, LocaleId.AustraliaEnglish, LocaleId.NewZealandEnglish],
  en_china: [LocaleId.ChinaEnglish],
};

/**
 * getLocalRegion function to extract the expected region name
 *
 * @param userLocalId: user locale id
 * @returns the region name to search for the JSON file to overwrite
 */
export const getLocalRegion = (userLocalId: number) => {
  const [regionName] = Object.entries(Regions).find(([, localeIds]) => localeIds.includes(userLocalId)) || [];
  return regionName;
};
